import { useRef, useState } from "react";

import { PhotoCamera } from "@mui/icons-material";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import html2canvas from "html2canvas";

import { CommentThemeCard } from "../CommentContent/CommentList/CommentThemeCard";

const ExportImage = ({ themeData }) => {
  const [isExporting, setIsExporting] = useState(false);
  const exportRef = useRef(null);

  const exportImage = async () => {
    if (!exportRef.current) return;
    setIsExporting(true);
    try {
      const canvas = await html2canvas(exportRef.current);
      const imageUrl = canvas.toDataURL("image/jpeg");
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `amplify_themes_${dayjs().format("DD_MM_YYYY")}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting image:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Button
        startIcon={<PhotoCamera />}
        onClick={exportImage}
        disabled={isExporting || !themeData || Object.keys(themeData).length === 0}
      >
        {isExporting ? "Exporting..." : "Export"}
      </Button>

      {/* Hidden container for image generation */}
      <div
        ref={exportRef}
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: "1200px", // Fixed width for consistent export
          backgroundColor: "#f9f9f9", // Match background
          padding: "40px",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)", // 3 columns like desktop view
          gap: "16px",
        }}
      >
        {themeData && Object.entries(themeData).map(([title, description]) => (
          <div key={title} style={{ height: "100%" }}>
            <CommentThemeCard
              title={title}
              description={description}
              isCommentsLoading={false}
              comments={[]}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ExportImage;
